import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { Button } from '~/eds/src/components/Button/Button';
import {
  GroupFormData,
  GroupFormModal,
} from '~/features/groups/GroupFormModal';
import { useCanEditEntityGroups } from '~/hooks/useCanEditEntityGroups';
import { api } from '~/redux/api/createApi';

const messages = defineMessages({
  newGroup: {
    id: 'WorkflowTicketsGroups.newGroup',
    defaultMessage: 'New Group',
    description: 'Button text for creating a new workflow group',
  },
  createGroup: {
    id: 'WorkflowTicketsGroups.createGroup',
    defaultMessage: 'Create Group',
    description: 'Primary action button text in the create group modal',
  },
  groupCreated: {
    id: 'WorkflowTicketsGroups.groupCreated',
    defaultMessage: '{groupName} has been created.',
    description: 'Success toast message after creating a group',
  },
});

export const NewGroupButton = () => {
  const { formatMessage } = useIntl();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const { hasPermission, isLoading: isPermissionLoading } =
    useCanEditEntityGroups();

  const [createGroup, { isLoading }] = api.endpoints.createGroup.useMutation();

  if (isPermissionLoading || !hasPermission) {
    return null;
  }

  const handleSubmit = async (data: GroupFormData) => {
    await createGroup({
      ...data,
      name: data.name.trim(),
      rtkQueryOptions: {
        showSuccessToast: formatMessage(messages.groupCreated, {
          groupName: data.name,
        }),
      },
    });
  };

  return (
    <>
      <Button
        text={formatMessage(messages.newGroup)}
        variant="primary"
        onClick={() => setIsModalVisible(true)}
      />

      <GroupFormModal
        isVisible={isModalVisible}
        onHide={() => setIsModalVisible(false)}
        onSubmit={handleSubmit}
        submitButtonText={formatMessage(messages.createGroup)}
        isLoading={isLoading}
      />
    </>
  );
};
